import React from 'react';
import { NoteColumnHeaderTitle } from 'flux/stores/cuesheet/CuesheetConstants';
import ColumnMenu from 'main/components/show/cuesheet/columnHeaderCell/noteColumnMenu.jsx';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

/**
 * Note header cell
 *
 */
export default React.createClass({
  displayName: 'NoteColumnHeaderCell',

  render() {
    return (
      <WithTooltip placement="top" tip={TooltipConstants.CSNoteHeaderCell}>
        <div className="cs-header-cell">
          {NoteColumnHeaderTitle}
          <div className="caret-right">
            <ColumnMenu {...this.props} />
          </div>
        </div>
      </WithTooltip>
    );
  },
});
